var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.displayedAnswer),function(answer){return (
        _vm.displayedAnswer.length > 0
        )?_c('div',{staticClass:"question-content"},[_c('b',[_vm._v("Answered:  ")]),_vm._v(" "+_vm._s(answer)+"\n    ")]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df8303e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game-detail/Surveys/ResultsQuestion.vue
// module id = null
// module chunks = 